module.exports = __webpack_public_path__ + "img/2025-11-17a_2.a66a58f4.jpg";